import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConsumersService } from '../../consumers.service';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { EditPromocodeHistoryComponent } from './edit-promocode-history/edit-promocode-history.component';
import { CurrencyPipe } from '@angular/common';


@Component({
  selector: 'app-promocode-history',
  templateUrl: './promocode-history.component.html',
  styleUrls: ['./promocode-history.component.scss'],
  providers:[CurrencyPipe]
})
export class PromocodeHistoryComponent extends FeaturesBaseComponent implements OnInit {
  searchValue; 
  gridApi: any;
  gridColumnApi: any;
  promoCodeHistoryData: any = [];
  promoCodeHistoryColumnDef: any = [];
  userId: any;
  constructor(private activeRoute: ActivatedRoute, 
    private dialog: MatDialog,
     private router: Router, 
    private consumersService: ConsumersService,
     private currencyPipe: CurrencyPipe
  ) {
    super();
    this.userId =this.activeRoute.snapshot.params.userId;
    this.getConsumerPromoCodeHistory();
  }
  getConsumerPromoCodeHistory() {
      this.consumersService.consumerPromocodePointHistory(this.userId).subscribe(res => {
      this.promoCodeHistoryData = res['data']
      // this.gridApi.refreshCells();

    })
  }

  ngOnInit(): void {
    super.ngOnInit();
    const self = this;
    this.promoCodeHistoryColumnDef = [
      { field: 'promocodeId', headerName: 'promocodeId', width: 0, hide: true, sort: "desc" },
      { field: 'promocodeNumber', headerName: 'Promo Code' },
      { field: 'discountValue', headerName: 'Promo Code Amount',  cellRenderer: (params) => {
        return  this.currencyPipe.transform(params.value)
      }},
      // { field: 'description', headerName: 'Description', width: 160 },
      { field: 'codeGroup', headerName: 'Code Group', width: 180 },
      { field: 'carrier', headerName: 'Carrier', width: 140 },
      { field: 'country', headerName: 'Country', width: 160 },
      { field: 'notificationSentDttm', headerName: 'Promo code Issue date', width: 350 , cellRenderer: (data) => { if(data.value){return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');}}},
      { field: 'promocodeUsageDateTime', headerName: 'Promo code Redeemed date', width: 350, cellRenderer: (data) => { if(data.value){return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');}}},
      // { field: 'count', headerName: 'No. of Times Redeemed', width: 330 },
      { field: 'promocodeEndDateTime', headerName: 'Validity', width: 330 ,
      cellRenderer: (params) => {
        if (!params.node.data.promocodeUsageDateTime && params.node.data.promocodeUsageDateTime==null) {
            return `${moment(params.value).utc().format('MM/DD/YYYY hh:mm:ss:a')}  &nbsp;<span class="rounded-pill bg-main text-white px-2 py-1 cur-point">Edit</span>`
          }else{
           return `${moment(params.value).utc().format('MM/DD/YYYY hh:mm:ss:a')}`
          }
        
      }
      , onCellClicked: function (params) {
        if (params && params.value && params.node.data.promocodeUsageDateTime==null) {
          const dialogRef = self.dialog.open(EditPromocodeHistoryComponent, {
            width: 'auto',
            data: params.data
          });
          dialogRef.afterClosed().subscribe(result => {
            self.getConsumerPromoCodeHistory();
          })
        }
      }, 
    },   
    ]
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


}